import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import * as z from "zod/mini";
import { locationLayoutRoute, locationsListRoute } from "./locations";
import { signedUpRoute } from "./signedUp";

const billingModeSchema = z._default(z.enum(["view", "edit-custom", "add-custom"]), "view");

const stripeRedirectSearchSchema = z.object({
  redirect_status: z.optional(z.string()),
  setup_intent: z.optional(z.string()),
  setup_intent_client_secret: z.optional(z.string()),
  updated_location_id: z.optional(z.number()),
  updated_org_id: z.optional(z.string()),
});

// ManageOrganization tab-switches internally against built paths (not a nested <Routes>), so one
// splat route covers the whole subtree; the billing tab's `mode` (+ Stripe redirect params) live
// on its search.
export const orgDetailsRoute = createRoute({
  getParentRoute: () => signedUpRoute,
  path: "organizations/$organizationId/$",
  validateSearch: z.extend(stripeRedirectSearchSchema, { mode: billingModeSchema }),
  component: lazyRouteComponent(() => import("domains/orgs/views/ManageOrganization"), "ManageOrganization"),
});

const locationsIndexRoute = createRoute({
  getParentRoute: () => locationsListRoute,
  path: "/",
  component: lazyRouteComponent(() => import("domains/orgs/views/OrganizationOverview"), "OrganizationOverviewView"),
});

const locationsAddRoute = createRoute({
  getParentRoute: () => locationsListRoute,
  path: "add",
  validateSearch: z.object({ returnTo: z.optional(z.string()) }),
  component: lazyRouteComponent(() => import("domains/orgs/views/OrganizationOverview"), "OrganizationOverviewView"),
});

export const locationsListRoutes = [locationsIndexRoute, locationsAddRoute];

const locationTeamRoute = createRoute({
  getParentRoute: () => locationLayoutRoute,
  path: "teams",
  component: lazyRouteComponent(() => import("domains/locations/views/ManageLocation"), "ManageLocation"),
});

const locationInfoRoute = createRoute({
  getParentRoute: () => locationLayoutRoute,
  path: "info",
  component: lazyRouteComponent(() => import("domains/locations/views/ManageLocation"), "ManageLocation"),
});

export const locationBillingRoute = createRoute({
  getParentRoute: () => locationLayoutRoute,
  path: "billing",
  validateSearch: z.extend(stripeRedirectSearchSchema, {
    mode: billingModeSchema,
    returnTo: z.optional(z.string()),
  }),
  component: lazyRouteComponent(() => import("domains/locations/views/ManageLocation"), "ManageLocation"),
});

const locationAddOnsRoute = createRoute({
  getParentRoute: () => locationLayoutRoute,
  path: "add-ons",
  component: lazyRouteComponent(() => import("domains/locations/views/LocationAddOns"), "LocationAddOns"),
});

const locationOrgRemapRoute = createRoute({
  getParentRoute: () => locationLayoutRoute,
  path: "org-remap",
  component: lazyRouteComponent(() => import("domains/locations/views/LocationOrgRemap"), "LocationOrgRemap"),
});

export const locationSettingsRoutes = [
  locationTeamRoute,
  locationInfoRoute,
  locationBillingRoute,
  locationAddOnsRoute,
  locationOrgRemapRoute,
];
